import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  AppState, AppUser,
  getEnumKeyByEnumValue,
  Maybe,
  PlanActions,
  PlanDoc,
  PlanInput,
  PlanType
} from '../../../types';
import {FixedHeightContent, FlexRow, ScrollableContent} from '../../../constants/styles';
import Modal from 'antd/lib/modal/Modal';
import {generateRetirementPlan} from '../../../actions/plan';
import {Menu} from 'antd';
import {ExclamationCircleOutlined, RedoOutlined} from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import BasicPlanForm from './BasicPlanForm';
import {savedInputsToFieldInputs} from '../../../utils/plan';
import {
  AiOutlineInfo,
  AiOutlineMonitor,
  AiOutlineWarning,
  BsInfoCircle,
  FaEdit,
  IoInformationCircle
} from "react-icons/all";
import {to_date_string} from "../../../utils/misc";


type Props = {};

function renderMenuSection(
    selectedPlan: PlanDoc,
    selectedKey: string,
    closeModal: Function,
    generatePlan: Function,
    user: Maybe<AppUser>
) {
  switch(selectedKey) {
    case 'info':
      return <>
        <p style={{marginTop: '20px'}}>
          <b>Identificador:</b> {selectedPlan && selectedPlan.id}
        </p>
        <p>
          <b>Tipo de plan:</b> {selectedPlan && selectedPlan.plan_type}
        </p>
        <p>
          <b>Último intento:</b> {selectedPlan && to_date_string(selectedPlan.created_at)}
        </p>
      </>
    case 'diagnostic_data':
      return <>
        {(selectedPlan && selectedPlan.diagnostic_data) ? <p style={{marginTop: '20px'}}>
          {selectedPlan.diagnostic_data}
        </p> : <p style={{marginTop: '20px'}}>
          Este plan no tiene datos clave.
        </p>}
      </>
    case 'errors':
      return <>
        {(selectedPlan.error && !selectedPlan.success) && <FlexRow>
          <Text
              type="danger"
              style={{ padding: '10px 0' }}
          >
            {
              selectedPlan.error.message
            }
          </Text>
        </FlexRow>}
      </>
    case 'form':
      return <BasicPlanForm
          plan_type={selectedPlan.plan_type}
          inputs={{
            ...savedInputsToFieldInputs(selectedPlan.inputs),
            planId: selectedPlan.id,
          }}
          onSubmit={(data) => {
            closeModal();
            generatePlan(data, user);
          }}
          noFile={selectedPlan.rsc ? true : false}
      />
  }
}

export default function ErrorDetailsModal(props: Props) {
  const errorModalOpen = useSelector<AppState, boolean>(state => state.plans.errorModalOpen);
  const dispatch = useDispatch();
  const closeModal = () => dispatch({type: PlanActions.SET_ERROR_DETAILS_MODAL, payload: {open: false}});
  const generatePlan = (data: PlanInput, user: AppUser) => dispatch(generateRetirementPlan(data, user));
  const selectedPlan = useSelector<AppState, Maybe<PlanDoc>>(state => state.plans.selectedPlan);
  const user = useSelector<AppState, Maybe<AppUser>>(state => state.user.user);

  const handleMenuClick = (event: any) => {
    setSelectedKey(event.key);
  }
  const [selectedKey, setSelectedKey] = useState('errors');

  return (
    <FixedHeightContent
      maxHeight="60vh"

    >
      <Modal
        title={"Detalles del plan"}
        visible={errorModalOpen}
        footer={null}
        onCancel={() => {
          setSelectedKey('errors');
          closeModal();
        }}
        style={{width: "fit-content"}}
        >
        <ScrollableContent
          maxHeight="70vh"
          style={{width: "500px", marginLeft: "-10px" }}
        >
          <Menu
            onClick={handleMenuClick}
            selectedKeys={[selectedKey]}
            mode="horizontal"
          >
            <Menu.Item
                key="info"
                icon={<BsInfoCircle style={{paddingTop: '2px'}}/>}
            >
              Info
            </Menu.Item>
            <Menu.Item
                key="diagnostic_data"
                icon={<AiOutlineMonitor style={{paddingTop: '2px'}}/>}
            >
              Datos clave
            </Menu.Item>
            <Menu.Item
              key="errors"
              icon={<AiOutlineWarning />}
            >
              Errores
            </Menu.Item>
            <Menu.Item
              key="form"
              icon={(selectedPlan && !selectedPlan.success) ? <RedoOutlined /> : <FaEdit />}
            >
              { (selectedPlan && !selectedPlan.success) ? "Reintentar" : "Modificar"}
            </Menu.Item>
          </Menu>
          {
            selectedPlan && renderMenuSection(selectedPlan, selectedKey, closeModal, generatePlan, user)
          }
        </ScrollableContent>
        
      </Modal>
    </FixedHeightContent>
  );
}